/* tslint:disable */
/* eslint-disable */
/**
 * Joule Conductor Cloud
 * This specification document describes the Joule Technologies Application Programming Interface  (API). The endpoints, message formats and status codes are explained in this document. ## Communication  ### Base URI  The base Uniform Resource Identifier (URI) is: https://user-api.joule-cloud.com/v2 This URI is the prefix for all endpoints described in this document. ### Body format  The endpoints of the API expecting a body must be in JavaScript Object Notation (JSON) format.  Response bodies from the endpoints also adhere to this standard, unless otherwise stated.  Responses will include a Content-Type header indicating the ‘application/json’ type. An invalid  or missing body will result in a 400-status code accompanied by an error code to specify the  nature of the error. ### Security The API uses HTTPS as the underlying protocol to transfer data. The server hosts a certificate  to set up a secure connection using Transport Layer Security (TLS) version 1.2. The authenticity  of the server certificate is verifiable by the client using publicly available sources.  #### Authentication and authorization  The API should only be called by legitimate users with the correct access rights. The API uses  the Open Authorization 2.0 (OAuth) standard to achieve this. Every request to the API should  include a bearer access token in the JSON Web Token (JWT) format in the Authorization header.  The header should be formatted such as in the example below.  ```   {“Authorization”: “Bearer <JWT>”}  ``` The JWT must be acquired from one of the following identity providers:   * joule-technologies.eu.auth0.com    * inventum-app.eu.auth0.com    * joule-app.eu.auth0.com   For help regarding gaining an access token you can find the docs for Auth0  [here](https://auth0.com/docs/secure/tokens/access-tokens/get-access-tokens). The JWT must be intended for one of the following audiences:    * https://user-api.joule-cloud.com   If the authorization header does not match the requirements stated above the API will respond  with a 401-status code accompanied by an error code to specify the nature of the error.  ### Timeout The API specifies a maximum amount of time between a request and the response to avoid blocking  either side. The general timeout that has been set for each endpoint is 3000 milliseconds.  This timeout is used unless otherwise stated in the respective endpoint documentation.  If the server is unable to respond within this maximum time, the response contains a 504-status  code. The client may retry the request. The time out for a stream to be open is 1800 seconds.  If the stream is still open passed the experitation the server will close the stream. ### Rate limits  No rate limit is currently imposed. ### Diagnostics response  The diagnostics response provides the caller of the API with more information in case of a  failed request. This information can be used for debugging and recovery/retrying purposes.  The diagnostics response is always included under the “diagnostics” key if the response  has a body. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Devices,
  Diagnostics,
  Firmware,
  FirmwareResponse,
  Firmwares,
  LinkResult,
  LoggingLevel,
  LoggingLevelResult,
  ManagementCanEdit200Response,
  ManagementCreateDevice200Response,
  ManagementCreateDeviceRequest,
  ManagementGetDevice200Response,
  ManagementUpdateDeviceRequest,
  ManagementUpdateRoleRequest,
  Statistics,
  Translation,
  TranslationsArr,
  UpdateStatusWithDeviceInfo,
  UserRole,
} from '../models/index';
import {
    DevicesFromJSON,
    DevicesToJSON,
    DiagnosticsFromJSON,
    DiagnosticsToJSON,
    FirmwareFromJSON,
    FirmwareToJSON,
    FirmwareResponseFromJSON,
    FirmwareResponseToJSON,
    FirmwaresFromJSON,
    FirmwaresToJSON,
    LinkResultFromJSON,
    LinkResultToJSON,
    LoggingLevelFromJSON,
    LoggingLevelToJSON,
    LoggingLevelResultFromJSON,
    LoggingLevelResultToJSON,
    ManagementCanEdit200ResponseFromJSON,
    ManagementCanEdit200ResponseToJSON,
    ManagementCreateDevice200ResponseFromJSON,
    ManagementCreateDevice200ResponseToJSON,
    ManagementCreateDeviceRequestFromJSON,
    ManagementCreateDeviceRequestToJSON,
    ManagementGetDevice200ResponseFromJSON,
    ManagementGetDevice200ResponseToJSON,
    ManagementUpdateDeviceRequestFromJSON,
    ManagementUpdateDeviceRequestToJSON,
    ManagementUpdateRoleRequestFromJSON,
    ManagementUpdateRoleRequestToJSON,
    StatisticsFromJSON,
    StatisticsToJSON,
    TranslationFromJSON,
    TranslationToJSON,
    TranslationsArrFromJSON,
    TranslationsArrToJSON,
    UpdateStatusWithDeviceInfoFromJSON,
    UpdateStatusWithDeviceInfoToJSON,
    UserRoleFromJSON,
    UserRoleToJSON,
} from '../models/index';

export interface AcceptTranslationChangeRequest {
    translationId: string;
}

export interface ChangeFirmwareRequest {
    firmwareId: string;
    firmware: Firmware;
}

export interface CreateFirmwareRequest {
    firmware: Firmware;
}

export interface CreateTranslationChangeRequest {
    translation: Translation;
}

export interface GetSingleTranslationRequest {
    translationId: string;
}

export interface ManagementCreateDeviceOperationRequest {
    device: ManagementCreateDeviceRequest;
}

export interface ManagementGetDeviceRequest {
    deviceId: string;
}

export interface ManagementGetDevicesRequest {
    size?: number;
    page?: number;
    sort?: string;
    search?: string;
    errors?: Set<string>;
}

export interface ManagementGetDevicesRemoteLoggingRequest {
    size?: number;
    page?: number;
}

export interface ManagementGetFirmwareRequest {
    firmwareId: string;
}

export interface ManagementGetFirmwaresRequest {
    size?: number;
    page?: number;
    filter?: string;
    sort?: string;
}

export interface ManagementGetRoleRequest {
    roleId: string;
}

export interface ManagementGetTranslationsRequest {
    size?: number;
    page?: number;
    filter?: string;
    sort?: string;
}

export interface ManagementGetUpdateStatussesRequest {
    serialNumbers: Array<string>;
}

export interface ManagementLinkFirmwareRequest {
    firmwareId: string;
    serialNumbers: Array<string>;
}

export interface ManagementLoggingLevelsRequest {
    loggingLevel: LoggingLevel;
}

export interface ManagementUpdateDeviceOperationRequest {
    deviceId: string;
    device: ManagementUpdateDeviceRequest;
}

export interface ManagementUpdateRoleOperationRequest {
    roleId: string;
    permissions: ManagementUpdateRoleRequest;
}

export interface RejectTranslationChangeRequest {
    translationId: string;
}

export interface RemoveFirmwareRequest {
    firmwareId: string;
}

export interface UpdateFirmwareRequest {
    firmwareId: string;
    firmware: Firmware;
}

/**
 * 
 */
export class ManagementApi extends runtime.BaseAPI {

    /**
     * Creates request options for acceptTranslationChange without sending the request
     */
    async acceptTranslationChangeRequestOpts(requestParameters: AcceptTranslationChangeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['translationId'] == null) {
            throw new runtime.RequiredError(
                'translationId',
                'Required parameter "translationId" was null or undefined when calling acceptTranslationChange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/translations/{translationId}`;
        urlPath = urlPath.replace(`{${"translationId"}}`, encodeURIComponent(String(requestParameters['translationId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Accept a translation change
     */
    async acceptTranslationChangeRaw(requestParameters: AcceptTranslationChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.acceptTranslationChangeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Accept a translation change
     */
    async acceptTranslationChange(requestParameters: AcceptTranslationChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.acceptTranslationChangeRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for changeFirmware without sending the request
     */
    async changeFirmwareRequestOpts(requestParameters: ChangeFirmwareRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['firmwareId'] == null) {
            throw new runtime.RequiredError(
                'firmwareId',
                'Required parameter "firmwareId" was null or undefined when calling changeFirmware().'
            );
        }

        if (requestParameters['firmware'] == null) {
            throw new runtime.RequiredError(
                'firmware',
                'Required parameter "firmware" was null or undefined when calling changeFirmware().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/firmwares/{firmwareId}`;
        urlPath = urlPath.replace(`{${"firmwareId"}}`, encodeURIComponent(String(requestParameters['firmwareId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: FirmwareToJSON(requestParameters['firmware']),
        };
    }

    /**
     * Currently only supports changing the version (name) of a set.
     * Change part of an existing firmware.
     */
    async changeFirmwareRaw(requestParameters: ChangeFirmwareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.changeFirmwareRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Currently only supports changing the version (name) of a set.
     * Change part of an existing firmware.
     */
    async changeFirmware(requestParameters: ChangeFirmwareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.changeFirmwareRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for createFirmware without sending the request
     */
    async createFirmwareRequestOpts(requestParameters: CreateFirmwareRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['firmware'] == null) {
            throw new runtime.RequiredError(
                'firmware',
                'Required parameter "firmware" was null or undefined when calling createFirmware().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/firmwares`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FirmwareToJSON(requestParameters['firmware']),
        };
    }

    /**
     * Creates a new firmware version
     */
    async createFirmwareRaw(requestParameters: CreateFirmwareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.createFirmwareRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates a new firmware version
     */
    async createFirmware(requestParameters: CreateFirmwareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createFirmwareRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for createTranslationChange without sending the request
     */
    async createTranslationChangeRequestOpts(requestParameters: CreateTranslationChangeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['translation'] == null) {
            throw new runtime.RequiredError(
                'translation',
                'Required parameter "translation" was null or undefined when calling createTranslationChange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/translations`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TranslationToJSON(requestParameters['translation']),
        };
    }

    /**
     * Creates a new change request for a translation
     */
    async createTranslationChangeRaw(requestParameters: CreateTranslationChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.createTranslationChangeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates a new change request for a translation
     */
    async createTranslationChange(requestParameters: CreateTranslationChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createTranslationChangeRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getSingleTranslation without sending the request
     */
    async getSingleTranslationRequestOpts(requestParameters: GetSingleTranslationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['translationId'] == null) {
            throw new runtime.RequiredError(
                'translationId',
                'Required parameter "translationId" was null or undefined when calling getSingleTranslation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/translations/{translationId}`;
        urlPath = urlPath.replace(`{${"translationId"}}`, encodeURIComponent(String(requestParameters['translationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get single translation
     */
    async getSingleTranslationRaw(requestParameters: GetSingleTranslationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Translation>> {
        const requestOptions = await this.getSingleTranslationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TranslationFromJSON(jsonValue));
    }

    /**
     * Get single translation
     */
    async getSingleTranslation(requestParameters: GetSingleTranslationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Translation> {
        const response = await this.getSingleTranslationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for managementCanEdit without sending the request
     */
    async managementCanEditRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/can-edit`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Whether the current user can edit
     */
    async managementCanEditRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ManagementCanEdit200Response>> {
        const requestOptions = await this.managementCanEditRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManagementCanEdit200ResponseFromJSON(jsonValue));
    }

    /**
     * Whether the current user can edit
     */
    async managementCanEdit(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ManagementCanEdit200Response> {
        const response = await this.managementCanEditRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for managementCreateDevice without sending the request
     */
    async managementCreateDeviceRequestOpts(requestParameters: ManagementCreateDeviceOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['device'] == null) {
            throw new runtime.RequiredError(
                'device',
                'Required parameter "device" was null or undefined when calling managementCreateDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", ["admin", "technician"]);
        }


        let urlPath = `/v2/management/devices`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ManagementCreateDeviceRequestToJSON(requestParameters['device']),
        };
    }

    /**
     * Pre-create a device
     */
    async managementCreateDeviceRaw(requestParameters: ManagementCreateDeviceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ManagementCreateDevice200Response>> {
        const requestOptions = await this.managementCreateDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManagementCreateDevice200ResponseFromJSON(jsonValue));
    }

    /**
     * Pre-create a device
     */
    async managementCreateDevice(requestParameters: ManagementCreateDeviceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ManagementCreateDevice200Response> {
        const response = await this.managementCreateDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for managementGetDevice without sending the request
     */
    async managementGetDeviceRequestOpts(requestParameters: ManagementGetDeviceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling managementGetDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/devices/{deviceId}`;
        urlPath = urlPath.replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters['deviceId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get one specific device
     */
    async managementGetDeviceRaw(requestParameters: ManagementGetDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ManagementGetDevice200Response>> {
        const requestOptions = await this.managementGetDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManagementGetDevice200ResponseFromJSON(jsonValue));
    }

    /**
     * Get one specific device
     */
    async managementGetDevice(requestParameters: ManagementGetDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ManagementGetDevice200Response> {
        const response = await this.managementGetDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for managementGetDevices without sending the request
     */
    async managementGetDevicesRequestOpts(requestParameters: ManagementGetDevicesRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['errors'] != null) {
            queryParameters['errors'] = Array.from(requestParameters['errors'])!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/devices`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a paginated list of devices
     */
    async managementGetDevicesRaw(requestParameters: ManagementGetDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Devices>> {
        const requestOptions = await this.managementGetDevicesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevicesFromJSON(jsonValue));
    }

    /**
     * Get a paginated list of devices
     */
    async managementGetDevices(requestParameters: ManagementGetDevicesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Devices> {
        const response = await this.managementGetDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for managementGetDevicesRemoteLogging without sending the request
     */
    async managementGetDevicesRemoteLoggingRequestOpts(requestParameters: ManagementGetDevicesRemoteLoggingRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/devices/remote-logging`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a paginated list of devices with remote logging enabled
     */
    async managementGetDevicesRemoteLoggingRaw(requestParameters: ManagementGetDevicesRemoteLoggingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Devices>> {
        const requestOptions = await this.managementGetDevicesRemoteLoggingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DevicesFromJSON(jsonValue));
    }

    /**
     * Get a paginated list of devices with remote logging enabled
     */
    async managementGetDevicesRemoteLogging(requestParameters: ManagementGetDevicesRemoteLoggingRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Devices> {
        const response = await this.managementGetDevicesRemoteLoggingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for managementGetFirmware without sending the request
     */
    async managementGetFirmwareRequestOpts(requestParameters: ManagementGetFirmwareRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['firmwareId'] == null) {
            throw new runtime.RequiredError(
                'firmwareId',
                'Required parameter "firmwareId" was null or undefined when calling managementGetFirmware().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/firmwares/{firmwareId}`;
        urlPath = urlPath.replace(`{${"firmwareId"}}`, encodeURIComponent(String(requestParameters['firmwareId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a single firmware
     */
    async managementGetFirmwareRaw(requestParameters: ManagementGetFirmwareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FirmwareResponse>> {
        const requestOptions = await this.managementGetFirmwareRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FirmwareResponseFromJSON(jsonValue));
    }

    /**
     * Get a single firmware
     */
    async managementGetFirmware(requestParameters: ManagementGetFirmwareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FirmwareResponse> {
        const response = await this.managementGetFirmwareRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for managementGetFirmwares without sending the request
     */
    async managementGetFirmwaresRequestOpts(requestParameters: ManagementGetFirmwaresRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/firmwares`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a paginated list of firmware
     */
    async managementGetFirmwaresRaw(requestParameters: ManagementGetFirmwaresRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Firmwares>> {
        const requestOptions = await this.managementGetFirmwaresRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FirmwaresFromJSON(jsonValue));
    }

    /**
     * Get a paginated list of firmware
     */
    async managementGetFirmwares(requestParameters: ManagementGetFirmwaresRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Firmwares> {
        const response = await this.managementGetFirmwaresRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for managementGetRole without sending the request
     */
    async managementGetRoleRequestOpts(requestParameters: ManagementGetRoleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling managementGetRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/roles/{roleId}`;
        urlPath = urlPath.replace(`{${"roleId"}}`, encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a role with permissions
     */
    async managementGetRoleRaw(requestParameters: ManagementGetRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserRole>> {
        const requestOptions = await this.managementGetRoleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserRoleFromJSON(jsonValue));
    }

    /**
     * Get a role with permissions
     */
    async managementGetRole(requestParameters: ManagementGetRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserRole> {
        const response = await this.managementGetRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for managementGetRoles without sending the request
     */
    async managementGetRolesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/roles`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Gets the list of all roles
     */
    async managementGetRolesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserRole>>> {
        const requestOptions = await this.managementGetRolesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserRoleFromJSON));
    }

    /**
     * Gets the list of all roles
     */
    async managementGetRoles(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserRole>> {
        const response = await this.managementGetRolesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for managementGetStatistics without sending the request
     */
    async managementGetStatisticsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/statistics`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Gets the statistics for the last 30 days
     */
    async managementGetStatisticsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Statistics>> {
        const requestOptions = await this.managementGetStatisticsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatisticsFromJSON(jsonValue));
    }

    /**
     * Gets the statistics for the last 30 days
     */
    async managementGetStatistics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Statistics> {
        const response = await this.managementGetStatisticsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for managementGetTranslations without sending the request
     */
    async managementGetTranslationsRequestOpts(requestParameters: ManagementGetTranslationsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/translations`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get a list of translations
     */
    async managementGetTranslationsRaw(requestParameters: ManagementGetTranslationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TranslationsArr>> {
        const requestOptions = await this.managementGetTranslationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TranslationsArrFromJSON(jsonValue));
    }

    /**
     * Get a list of translations
     */
    async managementGetTranslations(requestParameters: ManagementGetTranslationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TranslationsArr> {
        const response = await this.managementGetTranslationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for managementGetUpdateStatusses without sending the request
     */
    async managementGetUpdateStatussesRequestOpts(requestParameters: ManagementGetUpdateStatussesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serialNumbers'] == null) {
            throw new runtime.RequiredError(
                'serialNumbers',
                'Required parameter "serialNumbers" was null or undefined when calling managementGetUpdateStatusses().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/devices/updatestatus`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['serialNumbers'],
        };
    }

    /**
     * Get update statusses for specified devices
     */
    async managementGetUpdateStatussesRaw(requestParameters: ManagementGetUpdateStatussesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UpdateStatusWithDeviceInfo>>> {
        const requestOptions = await this.managementGetUpdateStatussesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UpdateStatusWithDeviceInfoFromJSON));
    }

    /**
     * Get update statusses for specified devices
     */
    async managementGetUpdateStatusses(requestParameters: ManagementGetUpdateStatussesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UpdateStatusWithDeviceInfo>> {
        const response = await this.managementGetUpdateStatussesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for managementLinkFirmware without sending the request
     */
    async managementLinkFirmwareRequestOpts(requestParameters: ManagementLinkFirmwareRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['firmwareId'] == null) {
            throw new runtime.RequiredError(
                'firmwareId',
                'Required parameter "firmwareId" was null or undefined when calling managementLinkFirmware().'
            );
        }

        if (requestParameters['serialNumbers'] == null) {
            throw new runtime.RequiredError(
                'serialNumbers',
                'Required parameter "serialNumbers" was null or undefined when calling managementLinkFirmware().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/firmwares/{firmwareId}/link`;
        urlPath = urlPath.replace(`{${"firmwareId"}}`, encodeURIComponent(String(requestParameters['firmwareId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['serialNumbers'],
        };
    }

    /**
     * Links given devices to a firmware
     */
    async managementLinkFirmwareRaw(requestParameters: ManagementLinkFirmwareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LinkResult>> {
        const requestOptions = await this.managementLinkFirmwareRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LinkResultFromJSON(jsonValue));
    }

    /**
     * Links given devices to a firmware
     */
    async managementLinkFirmware(requestParameters: ManagementLinkFirmwareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LinkResult> {
        const response = await this.managementLinkFirmwareRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for managementLoggingLevels without sending the request
     */
    async managementLoggingLevelsRequestOpts(requestParameters: ManagementLoggingLevelsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['loggingLevel'] == null) {
            throw new runtime.RequiredError(
                'loggingLevel',
                'Required parameter "loggingLevel" was null or undefined when calling managementLoggingLevels().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/debugging/logginglevels`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LoggingLevelToJSON(requestParameters['loggingLevel']),
        };
    }

    /**
     * Update the logging levels
     */
    async managementLoggingLevelsRaw(requestParameters: ManagementLoggingLevelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoggingLevelResult>> {
        const requestOptions = await this.managementLoggingLevelsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoggingLevelResultFromJSON(jsonValue));
    }

    /**
     * Update the logging levels
     */
    async managementLoggingLevels(requestParameters: ManagementLoggingLevelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoggingLevelResult> {
        const response = await this.managementLoggingLevelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for managementUpdateDevice without sending the request
     */
    async managementUpdateDeviceRequestOpts(requestParameters: ManagementUpdateDeviceOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling managementUpdateDevice().'
            );
        }

        if (requestParameters['device'] == null) {
            throw new runtime.RequiredError(
                'device',
                'Required parameter "device" was null or undefined when calling managementUpdateDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/devices/{deviceId}`;
        urlPath = urlPath.replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters['deviceId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ManagementUpdateDeviceRequestToJSON(requestParameters['device']),
        };
    }

    /**
     * Update a device
     */
    async managementUpdateDeviceRaw(requestParameters: ManagementUpdateDeviceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.managementUpdateDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a device
     */
    async managementUpdateDevice(requestParameters: ManagementUpdateDeviceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.managementUpdateDeviceRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for managementUpdateRole without sending the request
     */
    async managementUpdateRoleRequestOpts(requestParameters: ManagementUpdateRoleOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling managementUpdateRole().'
            );
        }

        if (requestParameters['permissions'] == null) {
            throw new runtime.RequiredError(
                'permissions',
                'Required parameter "permissions" was null or undefined when calling managementUpdateRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/roles/{roleId}`;
        urlPath = urlPath.replace(`{${"roleId"}}`, encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ManagementUpdateRoleRequestToJSON(requestParameters['permissions']),
        };
    }

    /**
     * Update a role\'s permissions
     */
    async managementUpdateRoleRaw(requestParameters: ManagementUpdateRoleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.managementUpdateRoleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a role\'s permissions
     */
    async managementUpdateRole(requestParameters: ManagementUpdateRoleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.managementUpdateRoleRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for rejectTranslationChange without sending the request
     */
    async rejectTranslationChangeRequestOpts(requestParameters: RejectTranslationChangeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['translationId'] == null) {
            throw new runtime.RequiredError(
                'translationId',
                'Required parameter "translationId" was null or undefined when calling rejectTranslationChange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/translations/{translationId}`;
        urlPath = urlPath.replace(`{${"translationId"}}`, encodeURIComponent(String(requestParameters['translationId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Reject a translation change
     */
    async rejectTranslationChangeRaw(requestParameters: RejectTranslationChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.rejectTranslationChangeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reject a translation change
     */
    async rejectTranslationChange(requestParameters: RejectTranslationChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rejectTranslationChangeRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for removeFirmware without sending the request
     */
    async removeFirmwareRequestOpts(requestParameters: RemoveFirmwareRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['firmwareId'] == null) {
            throw new runtime.RequiredError(
                'firmwareId',
                'Required parameter "firmwareId" was null or undefined when calling removeFirmware().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/firmwares/{firmwareId}`;
        urlPath = urlPath.replace(`{${"firmwareId"}}`, encodeURIComponent(String(requestParameters['firmwareId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Remove an existing firmware
     */
    async removeFirmwareRaw(requestParameters: RemoveFirmwareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.removeFirmwareRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove an existing firmware
     */
    async removeFirmware(requestParameters: RemoveFirmwareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeFirmwareRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateFirmware without sending the request
     */
    async updateFirmwareRequestOpts(requestParameters: UpdateFirmwareRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['firmwareId'] == null) {
            throw new runtime.RequiredError(
                'firmwareId',
                'Required parameter "firmwareId" was null or undefined when calling updateFirmware().'
            );
        }

        if (requestParameters['firmware'] == null) {
            throw new runtime.RequiredError(
                'firmware',
                'Required parameter "firmware" was null or undefined when calling updateFirmware().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("key", []);
        }


        let urlPath = `/v2/management/firmwares/{firmwareId}`;
        urlPath = urlPath.replace(`{${"firmwareId"}}`, encodeURIComponent(String(requestParameters['firmwareId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FirmwareToJSON(requestParameters['firmware']),
        };
    }

    /**
     * Update an existing firmware
     */
    async updateFirmwareRaw(requestParameters: UpdateFirmwareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateFirmwareRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update an existing firmware
     */
    async updateFirmware(requestParameters: UpdateFirmwareRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateFirmwareRaw(requestParameters, initOverrides);
    }

}
